import { render, staticRenderFns } from "./EditCriticalityDialog.vue?vue&type=template&id=0e5e04f4"
import script from "./EditCriticalityDialog.vue?vue&type=script&lang=js"
export * from "./EditCriticalityDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports